/**
 * Swiper - slider plugin
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package Gambling.com
 */

import Swiper from 'swiper/bundle';

const surprisingSlider = () => {
    // configure Swiper to use modules
    const mySwiper = new Swiper('.swiper-container-surprising', {
        speed: 400,
        spaceBetween: 100,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        },
    });

    mySwiper.on('slideChange', () => {
        console.log('mySwiper: ', mySwiper);
        // console.log('mySwiper active index: ', mySwiper.activeIndex);
        console.log('mySwiper real index: ', mySwiper.realIndex);
    });
};

export default surprisingSlider;
